import { Container } from 'react-bootstrap'
import { YWPCreateAccount } from '../Block'
import { FaArrowLeft } from 'react-icons/fa'
import Link from 'next/link'

function MeetExperts (props) {

	
return (
<div>
    <div className="meet__Experts text-white">
        <Container className="text-center py-5">
            <h2 className="mt-4"><strong>Meet Our Expert Advisors and Curators</strong></h2>
            <p className="mb-4">Our content is written and curated by experts in various fields of health and wellness.</p>
            <YWPCreateAccount site={props.site} bgcolor="bg-white" txtcolor="text-green"/>
            <Link href="/"><a className="mx-auto text-white d-block mt-3 text-decoration-none"><FaArrowLeft className="mr-2"/> Go back</a></Link>
        </Container>
    </div>
	
	<style jsx global>{`
		.meet__Experts{
            background-image: url(../images/home/img-header-large-nutritional01.jpg);
            background-repeat: no-repeat;
            background-size: cover;
        }

        .meet__Experts h2{
            font-size:2.3rem;
        }

        .meet__Experts button{
            background-color:#fff!important;
            color:#43a649!important;
            border-color:#fff!important;
        }

        .meet__Experts button:hover{
            text-decoration:underline;
        }
		
		`}
	</style>
</div>
);
}

export default MeetExperts;